import { KepsSystemActionTypes } from "../constants/action-types";
export const setKepsSystemShortCodes = (shortCodes) => {
    return {
        type: KepsSystemActionTypes.SET_SHORT_CODES,
        payload: shortCodes
    }
}